import FullPageLoader from "../../components/FullPageLoader/FullPageLoader";
import ConfirmDialog from "../../components/ConfirmDialog/ConfirmDialog";
import React, { useCallback, useState, useEffect, useRef } from "react";
import SearchBar from "../../components/SearchBar/SearchBar";
import { useLoading } from "../../contexts/LoadingContext";
import LocationCard from "../../components/LocationCard/LocationCard";
import LocationService, { Location } from "../../services/LocationService";
import "./LocationPage.scss";
import Modal from "../../components/Modal/Modal";
import MapWithMarker from "../../components/MapWithMarker/MapWithMarker";
import noJobInfoGraphics from "./../../assets/images/no-data-infographics.svg";
import { useLoader } from "../../contexts/LoaderContext";
import { showToast } from "../../components/Toaster";

// const sampleLocations: Location[] = [] //For testing Empty

// Sample data for development (replace with API when backend is ready)
const sampleLocations: Location[] = [
  {
    id: 1,
    name: "Mumbai Central Warehouse",
    address: "123, Andheri Kurla Road, Mumbai, Maharashtra 400059",
    latitude: 19.076,
    longitude: 72.8777,
    label: "WAREHOUSE",
    description: "Main distribution center for Mumbai region",
    contactPerson: "John Doe",
    contactPhone: "+91-9876543210",
    contactEmail: "warehouse@company.com",
    isActive: true,
    createdAt: "2025-09-22T06:21:02.404Z",
    updatedAt: "2025-09-22T06:21:02.404Z",
  },
  {
    id: 2,
    name: "Mumbai Port Terminal",
    address: "456, Port Road, Mumbai, Maharashtra 400001",
    latitude: 18.9217,
    longitude: 72.8347,
    label: "PORT",
    description: "Port terminal for import/export",
    contactPerson: "Jane Smith",
    contactPhone: "+91-9876543211",
    contactEmail: "port@company.com",
    isActive: true,
    createdAt: "2025-09-22T06:21:02.404Z",
    updatedAt: "2025-09-22T06:21:02.404Z",
  },
  {
    id: 3,
    name: "Pune Distribution Center",
    address: "789, Hinjewadi Road, Pune, Maharashtra 411057",
    latitude: 18.5204,
    longitude: 73.8567,
    label: "WAREHOUSE",
    description: "Distribution center for Pune region",
    contactPerson: "Rahul Mehta",
    contactPhone: "+91-9876543222",
    contactEmail: "pune@company.com",
    isActive: true,
    createdAt: "2025-09-22T06:21:02.404Z",
    updatedAt: "2025-09-22T06:21:02.404Z",
  },
  {
    id: 4,
    name: "Delhi North Hub",
    address: "101, Connaught Place, New Delhi, Delhi 110001",
    latitude: 28.6304,
    longitude: 77.2177,
    label: "HUB",
    description: "Northern hub for Delhi region",
    contactPerson: "Priya Singh",
    contactPhone: "+91-9876543233",
    contactEmail: "delhi@company.com",
    isActive: true,
    createdAt: "2025-09-22T06:21:02.404Z",
    updatedAt: "2025-09-22T06:21:02.404Z",
  },
  {
    id: 5,
    name: "Chennai Port",
    address: "202, Marina Beach Road, Chennai, Tamil Nadu 600001",
    latitude: 13.0827,
    longitude: 80.2707,
    label: "PORT",
    description: "Port terminal for Chennai",
    contactPerson: "Suresh Kumar",
    contactPhone: "+91-9876543244",
    contactEmail: "chennai@company.com",
    isActive: true,
    createdAt: "2025-09-22T06:21:02.404Z",
    updatedAt: "2025-09-22T06:21:02.404Z",
  },
  {
    id: 6,
    name: "Hyderabad Logistics Park",
    address: "Plot 12, Gachibowli, Hyderabad, Telangana 500032",
    latitude: 17.4448,
    longitude: 78.3498,
    label: "PARK",
    description: "Logistics park for Hyderabad",
    contactPerson: "Anil Reddy",
    contactPhone: "+91-9876543255",
    contactEmail: "hyderabad@company.com",
    isActive: true,
    createdAt: "2025-09-22T06:21:02.404Z",
    updatedAt: "2025-09-22T06:21:02.404Z",
  },
  {
    id: 7,
    name: "Bangalore South Hub",
    address: "No. 7, Electronic City, Bangalore, Karnataka 560100",
    latitude: 12.8452,
    longitude: 77.6604,
    label: "HUB",
    description: "Southern hub for Bangalore",
    contactPerson: "Meera Nair",
    contactPhone: "+91-9876543266",
    contactEmail: "bangalore@company.com",
    isActive: true,
    createdAt: "2025-09-22T06:21:02.404Z",
    updatedAt: "2025-09-22T06:21:02.404Z",
  },
  {
    id: 8,
    name: "Kolkata Port",
    address: "Dock 3, Strand Road, Kolkata, West Bengal 700001",
    latitude: 22.5726,
    longitude: 88.3639,
    label: "PORT",
    description: "Port terminal for Kolkata",
    contactPerson: "Arjun Das",
    contactPhone: "+91-9876543277",
    contactEmail: "kolkata@company.com",
    isActive: true,
    createdAt: "2025-09-22T06:21:02.404Z",
    updatedAt: "2025-09-22T06:21:02.404Z",
  },
  {
    id: 9,
    name: "Ahmedabad Distribution ",
    address: "Sector 21, Gandhinagar, Ahmedabad, Gujarat 382021",
    latitude: 23.0225,
    longitude: 72.5714,
    label: "WAREHOUSE",
    description: "Distribution center for Ahmedabad",
    contactPerson: "Ravi Patel",
    contactPhone: "+91-9876543288",
    contactEmail: "ahmedabad@company.com",
    isActive: true,
    createdAt: "2025-09-22T06:21:02.404Z",
    updatedAt: "2025-09-22T06:21:02.404Z",
  },
  {
    id: 10,
    name: "Jaipur North Hub",
    address: "Plot 5, Malviya Nagar, Jaipur, Rajasthan 302017",
    latitude: 26.9124,
    longitude: 75.7873,
    label: "HUB",
    description: "Northern hub for Jaipur",
    contactPerson: "Sunita Sharma",
    contactPhone: "+91-9876543299",
    contactEmail: "jaipur@company.com",
    isActive: true,
    createdAt: "2025-09-22T06:21:02.404Z",
    updatedAt: "2025-09-22T06:21:02.404Z",
  },
  {
    id: 11,
    name: "Hyderabad Logistics Park",
    address: "Plot 12, Gachibowli, Hyderabad, Telangana 500032",
    latitude: 17.4448,
    longitude: 78.3498,
    label: "PARK",
    description: "Logistics park for Hyderabad",
    contactPerson: "Anil Reddy",
    contactPhone: "+91-9876543255",
    contactEmail: "hyderabad@company.com",
    isActive: true,
    createdAt: "03/14/24 09:30",
    updatedAt: "03/14/24 09:30",
  },
  {
    id: 12,
    name: "Bangalore South Hub",
    address: "No. 7, Electronic City, Bangalore, Karnataka 560100",
    latitude: 12.8452,
    longitude: 77.6604,
    label: "HUB",
    description: "Southern hub for Bangalore",
    contactPerson: "Meera Nair",
    contactPhone: "+91-9876543266",
    contactEmail: "bangalore@company.com",
    isActive: true,
    createdAt: "03/15/24 12:00",
    updatedAt: "03/15/24 12:00",
  },
  {
    id: 13,
    name: "Kolkata Port",
    address: "Dock 3, Strand Road, Kolkata, West Bengal 700001",
    latitude: 22.5726,
    longitude: 88.3639,
    label: "PORT",
    description: "Port terminal for Kolkata",
    contactPerson: "Arjun Das",
    contactPhone: "+91-9876543277",
    contactEmail: "kolkata@company.com",
    isActive: true,
    createdAt: "03/16/24 15:20",
    updatedAt: "03/16/24 15:20",
  },
  {
    id: 14,
    name: "Ahmedabad Distribution ",
    address: "Sector 21, Gandhinagar, Ahmedabad, Gujarat 382021",
    latitude: 23.0225,
    longitude: 72.5714,
    label: "WAREHOUSE",
    description: "Distribution center for Ahmedabad",
    contactPerson: "Ravi Patel",
    contactPhone: "+91-9876543288",
    contactEmail: "ahmedabad@company.com",
    isActive: true,
    createdAt: "03/14/24 09:30",
    updatedAt: "03/17/24 10:10",
  },
  {
    id: 15,
    name: "Jaipur North Hub",
    address: "Plot 5, Malviya Nagar, Jaipur, Rajasthan 302017",
    latitude: 26.9124,
    longitude: 75.7873,
    label: "HUB",
    description: "Northern hub for Jaipur",
    contactPerson: "Sunita Sharma",
    contactPhone: "+91-9876543299",
    contactEmail: "jaipur@company.com",
    isActive: true,
    createdAt: "03/18/24 11:45",
    updatedAt: "03/18/24 11:45",
  },
  {
    id: 16,
    name: "Mumbai Central Warehouse",
    address: "123, Andheri Kurla Road, Mumbai, Maharashtra 400059",
    latitude: 19.076,
    longitude: 72.8777,
    label: "WAREHOUSE",
    description: "Main distribution center for Mumbai region",
    contactPerson: "John Doe",
    contactPhone: "+91-9876543210",
    contactEmail: "warehouse@company.com",
    isActive: true,
    createdAt: "03/10/24 10:30",
    updatedAt: "03/10/24 10:30",
  },
  {
    id: 17,
    name: "Mumbai Port Terminal",
    address: "456, Port Road, Mumbai, Maharashtra 400001",
    latitude: 18.9217,
    longitude: 72.8347,
    label: "PORT",
    description: "Port terminal for import/export",
    contactPerson: "Jane Smith",
    contactPhone: "+91-9876543211",
    contactEmail: "port@company.com",
    isActive: true,
    createdAt: "03/10/24 10:30",
    updatedAt: "03/10/24 10:30",
  },
  {
    id: 18,
    name: "Pune Distribution Center",
    address: "789, Hinjewadi Road, Pune, Maharashtra 411057",
    latitude: 18.5204,
    longitude: 73.8567,
    label: "WAREHOUSE",
    description: "Distribution center for Pune region",
    contactPerson: "Rahul Mehta",
    contactPhone: "+91-9876543222",
    contactEmail: "pune@company.com",
    isActive: true,
    createdAt: "03/11/24 09:00",
    updatedAt: "03/11/24 09:00",
  },
  {
    id: 19,
    name: "Delhi North Hub",
    address: "101, Connaught Place, New Delhi, Delhi 110001",
    latitude: 28.6304,
    longitude: 77.2177,
    label: "HUB",
    description: "Northern hub for Delhi region",
    contactPerson: "Priya Singh",
    contactPhone: "+91-9876543233",
    contactEmail: "delhi@company.com",
    isActive: true,
    createdAt: "03/12/24 11:30",
    updatedAt: "03/12/24 11:30",
  },
  {
    id: 20,
    name: "Chennai Port",
    address: "202, Marina Beach Road, Chennai, Tamil Nadu 600001",
    latitude: 13.0827,
    longitude: 80.2707,
    label: "PORT",
    description: "Port terminal for Chennai",
    contactPerson: "Suresh Kumar",
    contactPhone: "+91-9876543244",
    contactEmail: "chennai@company.com",
    isActive: true,
    createdAt: "03/13/24 14:45",
    updatedAt: "03/13/24 14:45",
  },
  {
    id: 21,
    name: "Hyderabad Logistics Park",
    address: "Plot 12, Gachibowli, Hyderabad, Telangana 500032",
    latitude: 17.4448,
    longitude: 78.3498,
    label: "PARK",
    description: "Logistics park for Hyderabad",
    contactPerson: "Anil Reddy",
    contactPhone: "+91-9876543255",
    contactEmail: "hyderabad@company.com",
    isActive: true,
    createdAt: "03/14/24 09:30",
    updatedAt: "03/14/24 09:30",
  },
  {
    id: 22,
    name: "Bangalore South Hub",
    address: "No. 7, Electronic City, Bangalore, Karnataka 560100",
    latitude: 12.8452,
    longitude: 77.6604,
    label: "HUB",
    description: "Southern hub for Bangalore",
    contactPerson: "Meera Nair",
    contactPhone: "+91-9876543266",
    contactEmail: "bangalore@company.com",
    isActive: true,
    createdAt: "03/15/24 12:00",
    updatedAt: "03/15/24 12:00",
  },
  {
    id: 23,
    name: "Kolkata Port",
    address: "Dock 3, Strand Road, Kolkata, West Bengal 700001",
    latitude: 22.5726,
    longitude: 88.3639,
    label: "PORT",
    description: "Port terminal for Kolkata",
    contactPerson: "Arjun Das",
    contactPhone: "+91-9876543277",
    contactEmail: "kolkata@company.com",
    isActive: true,
    createdAt: "03/16/24 15:20",
    updatedAt: "03/16/24 15:20",
  },
  {
    id: 24,
    name: "Ahmedabad Distribution ",
    address: "Sector 21, Gandhinagar, Ahmedabad, Gujarat 382021",
    latitude: 23.0225,
    longitude: 72.5714,
    label: "WAREHOUSE",
    description: "Distribution center for Ahmedabad",
    contactPerson: "Ravi Patel",
    contactPhone: "+91-9876543288",
    contactEmail: "ahmedabad@company.com",
    isActive: true,
    createdAt: "03/17/24 10:10",
    updatedAt: "03/17/24 10:10",
  },
  {
    id: 252,
    name: "Jaipur North Hub",
    address: "Plot 5, Malviya Nagar, Jaipur, Rajasthan 302017",
    latitude: 26.9124,
    longitude: 75.7873,
    label: "HUB",
    description: "Northern hub for Jaipur",
    contactPerson: "Sunita Sharma",
    contactPhone: "+91-9876543299",
    contactEmail: "jaipur@company.com",
    isActive: true,
    createdAt: "03/18/24 11:45",
    updatedAt: "03/18/24 11:45",
  },
  {
    id: 112,
    name: "Hyderabad Logistics Park",
    address: "Plot 12, Gachibowli, Hyderabad, Telangana 500032",
    latitude: 17.4448,
    longitude: 78.3498,
    label: "PARK",
    description: "Logistics park for Hyderabad",
    contactPerson: "Anil Reddy",
    contactPhone: "+91-9876543255",
    contactEmail: "hyderabad@company.com",
    isActive: true,
    createdAt: "03/14/24 09:30",
    updatedAt: "03/14/24 09:30",
  },
  {
    id: 25,
    name: "Bangalore South Hub",
    address: "No. 7, Electronic City, Bangalore, Karnataka 560100",
    latitude: 12.8452,
    longitude: 77.6604,
    label: "HUB",
    description: "Southern hub for Bangalore",
    contactPerson: "Meera Nair",
    contactPhone: "+91-9876543266",
    contactEmail: "bangalore@company.com",
    isActive: true,
    createdAt: "03/15/24 12:00",
    updatedAt: "03/15/24 12:00",
  },
  {
    id: 26,
    name: "Kolkata Port",
    address: "Dock 3, Strand Road, Kolkata, West Bengal 700001",
    latitude: 22.5726,
    longitude: 88.3639,
    label: "PORT",
    description: "Port terminal for Kolkata",
    contactPerson: "Arjun Das",
    contactPhone: "+91-9876543277",
    contactEmail: "kolkata@company.com",
    isActive: true,
    createdAt: "03/16/24 15:20",
    updatedAt: "03/16/24 15:20",
  },
  {
    id: 27,
    name: "Ahmedabad Distribution ",
    address: "Sector 21, Gandhinagar, Ahmedabad, Gujarat 382021",
    latitude: 23.0225,
    longitude: 72.5714,
    label: "WAREHOUSE",
    description: "Distribution center for Ahmedabad",
    contactPerson: "Ravi Patel",
    contactPhone: "+91-9876543288",
    contactEmail: "ahmedabad@company.com",
    isActive: true,
    createdAt: "03/14/24 09:30",
    updatedAt: "03/17/24 10:10",
  },
  {
    id: 28,
    name: "Jaipur North Hub",
    address: "Plot 5, Malviya Nagar, Jaipur, Rajasthan 302017",
    latitude: 26.9124,
    longitude: 75.7873,
    label: "HUB",
    description: "Northern hub for Jaipur",
    contactPerson: "Sunita Sharma",
    contactPhone: "+91-9876543299",
    contactEmail: "jaipur@company.com",
    isActive: true,
    createdAt: "03/18/24 11:45",
    updatedAt: "03/18/24 11:45",
  },
  {
    id: 29,
    name: "Mumbai Central Warehouse",
    address: "123, Andheri Kurla Road, Mumbai, Maharashtra 400059",
    latitude: 19.076,
    longitude: 72.8777,
    label: "WAREHOUSE",
    description: "Main distribution center for Mumbai region",
    contactPerson: "John Doe",
    contactPhone: "+91-9876543210",
    contactEmail: "warehouse@company.com",
    isActive: true,
    createdAt: "03/10/24 10:30",
    updatedAt: "03/10/24 10:30",
  },
  {
    id: 30,
    name: "Mumbai Port Terminal",
    address: "456, Port Road, Mumbai, Maharashtra 400001",
    latitude: 18.9217,
    longitude: 72.8347,
    label: "PORT",
    description: "Port terminal for import/export",
    contactPerson: "Jane Smith",
    contactPhone: "+91-9876543211",
    contactEmail: "port@company.com",
    isActive: true,
    createdAt: "03/10/24 10:30",
    updatedAt: "03/10/24 10:30",
  },
  {
    id: 31,
    name: "Pune Distribution Center",
    address: "789, Hinjewadi Road, Pune, Maharashtra 411057",
    latitude: 18.5204,
    longitude: 73.8567,
    label: "WAREHOUSE",
    description: "Distribution center for Pune region",
    contactPerson: "Rahul Mehta",
    contactPhone: "+91-9876543222",
    contactEmail: "pune@company.com",
    isActive: true,
    createdAt: "03/11/24 09:00",
    updatedAt: "03/11/24 09:00",
  },
  {
    id: 32,
    name: "Delhi North Hub",
    address: "101, Connaught Place, New Delhi, Delhi 110001",
    latitude: 28.6304,
    longitude: 77.2177,
    label: "HUB",
    description: "Northern hub for Delhi region",
    contactPerson: "Priya Singh",
    contactPhone: "+91-9876543233",
    contactEmail: "delhi@company.com",
    isActive: true,
    createdAt: "03/12/24 11:30",
    updatedAt: "03/12/24 11:30",
  },
  {
    id: 33,
    name: "Chennai Port",
    address: "202, Marina Beach Road, Chennai, Tamil Nadu 600001",
    latitude: 13.0827,
    longitude: 80.2707,
    label: "PORT",
    description: "Port terminal for Chennai",
    contactPerson: "Suresh Kumar",
    contactPhone: "+91-9876543244",
    contactEmail: "chennai@company.com",
    isActive: true,
    createdAt: "03/13/24 14:45",
    updatedAt: "03/13/24 14:45",
  },
  {
    id: 34,
    name: "Hyderabad Logistics Park",
    address: "Plot 12, Gachibowli, Hyderabad, Telangana 500032",
    latitude: 17.4448,
    longitude: 78.3498,
    label: "PARK",
    description: "Logistics park for Hyderabad",
    contactPerson: "Anil Reddy",
    contactPhone: "+91-9876543255",
    contactEmail: "hyderabad@company.com",
    isActive: true,
    createdAt: "03/14/24 09:30",
    updatedAt: "03/14/24 09:30",
  },
  {
    id: 35,
    name: "Bangalore South Hub",
    address: "No. 7, Electronic City, Bangalore, Karnataka 560100",
    latitude: 12.8452,
    longitude: 77.6604,
    label: "HUB",
    description: "Southern hub for Bangalore",
    contactPerson: "Meera Nair",
    contactPhone: "+91-9876543266",
    contactEmail: "bangalore@company.com",
    isActive: true,
    createdAt: "03/15/24 12:00",
    updatedAt: "03/15/24 12:00",
  },
  {
    id: 36,
    name: "Kolkata Port",
    address: "Dock 3, Strand Road, Kolkata, West Bengal 700001",
    latitude: 22.5726,
    longitude: 88.3639,
    label: "PORT",
    description: "Port terminal for Kolkata",
    contactPerson: "Arjun Das",
    contactPhone: "+91-9876543277",
    contactEmail: "kolkata@company.com",
    isActive: true,
    createdAt: "03/16/24 15:20",
    updatedAt: "03/16/24 15:20",
  },
  {
    id: 37,
    name: "Ahmedabad Distribution ",
    address: "Sector 21, Gandhinagar, Ahmedabad, Gujarat 382021",
    latitude: 23.0225,
    longitude: 72.5714,
    label: "WAREHOUSE",
    description: "Distribution center for Ahmedabad",
    contactPerson: "Ravi Patel",
    contactPhone: "+91-9876543288",
    contactEmail: "ahmedabad@company.com",
    isActive: true,
    createdAt: "03/17/24 10:10",
    updatedAt: "03/17/24 10:10",
  },
  {
    id: 38,
    name: "Jaipur North Hub",
    address: "Plot 5, Malviya Nagar, Jaipur, Rajasthan 302017",
    latitude: 26.9124,
    longitude: 75.7873,
    label: "HUB",
    description: "Northern hub for Jaipur",
    contactPerson: "Sunita Sharma",
    contactPhone: "+91-9876543299",
    contactEmail: "jaipur@company.com",
    isActive: true,
    createdAt: "03/18/24 11:45",
    updatedAt: "03/18/24 11:45",
  },
  {
    id: 39,
    name: "Hyderabad Logistics Park",
    address: "Plot 12, Gachibowli, Hyderabad, Telangana 500032",
    latitude: 17.4448,
    longitude: 78.3498,
    label: "PARK",
    description: "Logistics park for Hyderabad",
    contactPerson: "Anil Reddy",
    contactPhone: "+91-9876543255",
    contactEmail: "hyderabad@company.com",
    isActive: true,
    createdAt: "03/14/24 09:30",
    updatedAt: "03/14/24 09:30",
  },
  {
    id: 40,
    name: "Bangalore South Hub",
    address: "No. 7, Electronic City, Bangalore, Karnataka 560100",
    latitude: 12.8452,
    longitude: 77.6604,
    label: "HUB",
    description: "Southern hub for Bangalore",
    contactPerson: "Meera Nair",
    contactPhone: "+91-9876543266",
    contactEmail: "bangalore@company.com",
    isActive: true,
    createdAt: "03/15/24 12:00",
    updatedAt: "03/15/24 12:00",
  },
  {
    id: 41,
    name: "Kolkata Port",
    address: "Dock 3, Strand Road, Kolkata, West Bengal 700001",
    latitude: 22.5726,
    longitude: 88.3639,
    label: "PORT",
    description: "Port terminal for Kolkata",
    contactPerson: "Arjun Das",
    contactPhone: "+91-9876543277",
    contactEmail: "kolkata@company.com",
    isActive: true,
    createdAt: "03/16/24 15:20",
    updatedAt: "03/16/24 15:20",
  },
  {
    id: 42,
    name: "Ahmedabad Distribution ",
    address: "Sector 21, Gandhinagar, Ahmedabad, Gujarat 382021",
    latitude: 23.0225,
    longitude: 72.5714,
    label: "WAREHOUSE",
    description: "Distribution center for Ahmedabad",
    contactPerson: "Ravi Patel",
    contactPhone: "+91-9876543288",
    contactEmail: "ahmedabad@company.com",
    isActive: true,
    createdAt: "03/14/24 09:30",
    updatedAt: "03/17/24 10:10",
  },
  {
    id: 43,
    name: "Jaipur North Hub",
    address: "Plot 5, Malviya Nagar, Jaipur, Rajasthan 302017",
    latitude: 26.9124,
    longitude: 75.7873,
    label: "HUB",
    description: "Northern hub for Jaipur",
    contactPerson: "Sunita Sharma",
    contactPhone: "+91-9876543299",
    contactEmail: "jaipur@company.com",
    isActive: true,
    createdAt: "03/18/24 11:45",
    updatedAt: "03/18/24 11:45",
  },
  {
    id: 44,
    name: "Mumbai Central Warehouse",
    address: "123, Andheri Kurla Road, Mumbai, Maharashtra 400059",
    latitude: 19.076,
    longitude: 72.8777,
    label: "WAREHOUSE",
    description: "Main distribution center for Mumbai region",
    contactPerson: "John Doe",
    contactPhone: "+91-9876543210",
    contactEmail: "warehouse@company.com",
    isActive: true,
    createdAt: "03/10/24 10:30",
    updatedAt: "03/10/24 10:30",
  },
  {
    id: 45,
    name: "Mumbai Port Terminal",
    address: "456, Port Road, Mumbai, Maharashtra 400001",
    latitude: 18.9217,
    longitude: 72.8347,
    label: "PORT",
    description: "Port terminal for import/export",
    contactPerson: "Jane Smith",
    contactPhone: "+91-9876543211",
    contactEmail: "port@company.com",
    isActive: true,
    createdAt: "03/10/24 10:30",
    updatedAt: "03/10/24 10:30",
  },
  {
    id: 46,
    name: "Pune Distribution Center",
    address: "789, Hinjewadi Road, Pune, Maharashtra 411057",
    latitude: 18.5204,
    longitude: 73.8567,
    label: "WAREHOUSE",
    description: "Distribution center for Pune region",
    contactPerson: "Rahul Mehta",
    contactPhone: "+91-9876543222",
    contactEmail: "pune@company.com",
    isActive: true,
    createdAt: "03/11/24 09:00",
    updatedAt: "03/11/24 09:00",
  },
  {
    id: 47,
    name: "Delhi North Hub",
    address: "101, Connaught Place, New Delhi, Delhi 110001",
    latitude: 28.6304,
    longitude: 77.2177,
    label: "HUB",
    description: "Northern hub for Delhi region",
    contactPerson: "Priya Singh",
    contactPhone: "+91-9876543233",
    contactEmail: "delhi@company.com",
    isActive: true,
    createdAt: "03/12/24 11:30",
    updatedAt: "03/12/24 11:30",
  },
  {
    id: 48,
    name: "Chennai Port",
    address: "202, Marina Beach Road, Chennai, Tamil Nadu 600001",
    latitude: 13.0827,
    longitude: 80.2707,
    label: "PORT",
    description: "Port terminal for Chennai",
    contactPerson: "Suresh Kumar",
    contactPhone: "+91-9876543244",
    contactEmail: "chennai@company.com",
    isActive: true,
    createdAt: "03/13/24 14:45",
    updatedAt: "03/13/24 14:45",
  },
  {
    id: 49,
    name: "Hyderabad Logistics Park",
    address: "Plot 12, Gachibowli, Hyderabad, Telangana 500032",
    latitude: 17.4448,
    longitude: 78.3498,
    label: "PARK",
    description: "Logistics park for Hyderabad",
    contactPerson: "Anil Reddy",
    contactPhone: "+91-9876543255",
    contactEmail: "hyderabad@company.com",
    isActive: true,
    createdAt: "03/14/24 09:30",
    updatedAt: "03/14/24 09:30",
  },
  {
    id: 50,
    name: "Bangalore South Hub",
    address: "No. 7, Electronic City, Bangalore, Karnataka 560100",
    latitude: 12.8452,
    longitude: 77.6604,
    label: "HUB",
    description: "Southern hub for Bangalore",
    contactPerson: "Meera Nair",
    contactPhone: "+91-9876543266",
    contactEmail: "bangalore@company.com",
    isActive: true,
    createdAt: "03/15/24 12:00",
    updatedAt: "03/15/24 12:00",
  },
];

// Error bodies are not uniform: field-error object, plain text, or {message}/{detail}
const getErrorMessage = (err: any): string => {
  if (!err?.response) return "Network error. Please check your connection and try again.";
  const body = err.response.data;
  if (typeof body === "string" && body.trim()) return body;
  if (body?.message || body?.detail) return body.message || body.detail;
  if (body && typeof body === "object") {
    const fields = Object.entries(body)
      .filter(([, v]) => typeof v === "string")
      .map(([k, v]) => `${k}: ${v}`);
    if (fields.length) return fields.join(", ");
  }
  return err.response.status >= 500
    ? "Server error. Please try again."
    : "Request failed. Please check the entered values.";
};

function LocationPage() {
  // const isLoading = useRef(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [isMapModalOpen, setisMapModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState<"create" | "edit" | "view" | null>(
    null
  );
  const [selectedLocationId, setSelectedLocationId] = useState<number | null>(
    null
  );
  const [locationList, setLocationList] = useState<Location[]>([]);
  const [selectedLocation, setSelectedLocation] = useState<Location | null>(null);
  // filters (both parked for now): label dropdown and "nearby" (switches to GET /location/search)
  // const [label, setLabel] = useState("");
  const [label] = useState(""); // label filter parked: stays "All" (no label param sent)
  // Nearby search (GET /location/search) is parked for now: UI and handlers are commented out below.
  // const [nearbyInput, setNearbyInput] = useState({ lat: "", lng: "", radius: "10" });
  // const [nearbyError, setNearbyError] = useState("");
  // const [nearby, setNearby] = useState<{ latitude: number; longitude: number; radius: number } | null>(null);
  const [nearby] = useState<{ latitude: number; longitude: number; radius: number } | null>(null); // stays off while parked
  const [hasMore, setHasMore] = useState(true);
  const page = useRef(0);
  const pageSize = 30;
  const useApi = false; // Set to true to use API when backend is ready
  const useListApi = true; // List (GET /location) is live; the rest still use sample data
  const useDetailsApi = true; // GET /location/{id} is live
  const useCreateApi = true; // POST /location is live
  const useUpdateApi = true; // PUT /location/{id} is live
  const useDeleteApi = true; // DELETE /location/{id} is live
  const saveInFlight = useRef(false);
  const latestRequest = useRef(0); // ignores responses from outdated list requests
  const gridRef = useRef<HTMLDivElement>(null);

  const loader = useLoading();
  const { showLoader, hideLoader, isLoading: globalLoading } = useLoader();
  const [showTopBarLoader, setShowTopBarLoader] = useState(false);
  const [locationsLoaded, setLocationsLoaded] = useState(false);
  const initialLoadDone = useRef(false);

  // Unified loadLocations for API/sample
  const loadLocations = useCallback(
    async (reset = false) => {
      if (reset) {
        if (!initialLoadDone.current) {
          showLoader();
        }
        setShowTopBarLoader(false);
      } else {
        setShowTopBarLoader(true);
      }
      loader.setLoading(true);
      setLocationsLoaded(false);
      let filtered: Location[] = [];
      if (useListApi) {
        const requestId = ++latestRequest.current;
        const skip = page.current * pageSize;
        try {
          if (nearby) {
            // GET /location/search: nearest first, no skip / total, so one request returns everything (max 500)
            const res = await LocationService.searchLocations({
              q: searchQuery.trim(),
              label,
              latitude: nearby.latitude,
              longitude: nearby.longitude,
              radius: nearby.radius,
              limit: 500,
            });
            if (requestId !== latestRequest.current) return;
            filtered = res.data.data || [];
            setLocationList(filtered);
            setHasMore(false);
          } else {
            const res = await LocationService.getAllLocations({
              limit: pageSize,
              skip,
              search: searchQuery.trim(),
              label,
            });
            if (requestId !== latestRequest.current) return; // a newer request replaced this one
            filtered = res.data.data.content || [];
            setLocationList((prev) =>
              reset
                ? filtered
                : [...prev, ...filtered.filter((n) => !prev.some((p) => p.id === n.id))]
            );
            const total = res.data.data.page?.totalElements ?? 0;
            setHasMore(skip + filtered.length < total);
          }
        } catch (err) {
          if (requestId !== latestRequest.current) return;
          if (reset) setLocationList([]);
          setHasMore(false);
          showToast(getErrorMessage(err), "error");
        }
      } else {
        filtered = sampleLocations.filter(
          (loc: Location) =>
            loc.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
            loc.address.toLowerCase().includes(searchQuery.toLowerCase())
        );
        const start = page.current * pageSize;
        const newLocations = filtered.slice(start, start + pageSize);
        setLocationList((prev) =>
          reset ? newLocations : [...prev, ...newLocations]
        );
        if (start + pageSize >= filtered.length) setHasMore(false);
      }
      page.current += 1;
      setTimeout(() => {
        loader.setLoading(false);
        setShowTopBarLoader(false);
        setLocationsLoaded(true);
        if (reset && !initialLoadDone.current) {
          hideLoader();
          initialLoadDone.current = true;
        }
      }, 1000);
    },
    [searchQuery, label, nearby, pageSize, hasMore, useListApi, loader, showLoader, hideLoader]
  );

  // Initial load & search
  useEffect(() => {
    setLocationList([]);
    setHasMore(true);
    page.current = 0;
    loadLocations(true);
  }, [searchQuery, label, nearby, useListApi]);

  // Infinite scroll
  useEffect(() => {
    const handleScroll = () => {
      const grid = gridRef.current;
      if (!grid || loader.isLoading || !hasMore) return;
      const { scrollTop, scrollHeight, clientHeight } = grid;
      if (scrollHeight - scrollTop <= clientHeight * 1.5) {
        loadLocations();
      }
    };
    const grid = gridRef.current;
    if (grid) grid.addEventListener("scroll", handleScroll);
    return () => {
      if (grid) grid.removeEventListener("scroll", handleScroll);
    };
  }, [hasMore, loadLocations]);

  const handleSearchChange = useCallback((query: string) => {
    setSearchQuery(query);
  }, []);

  // --- parked: nearby search handlers ---
  // const applyNearby = () => {
  //   const { lat, lng, radius } = nearbyInput;
  //   if (!lat.trim() || !lng.trim() || !radius.trim()) {
  //     setNearbyError("Enter latitude, longitude and radius together");
  //     return;
  //   }
  //   const latitude = Number(lat);
  //   const longitude = Number(lng);
  //   const r = Number(radius);
  //   if (!Number.isFinite(latitude) || latitude < -90 || latitude > 90) {
  //     setNearbyError("Latitude must be between -90 and 90");
  //     return;
  //   }
  //   if (!Number.isFinite(longitude) || longitude < -180 || longitude > 180) {
  //     setNearbyError("Longitude must be between -180 and 180");
  //     return;
  //   }
  //   if (!Number.isFinite(r) || r <= 0) {
  //     setNearbyError("Radius must be greater than 0 km");
  //     return;
  //   }
  //   setNearbyError("");
  //   setNearby({ latitude, longitude, radius: r });
  // };

  // const clearNearby = () => {
  //   setNearby(null);
  //   setNearbyError("");
  // };

  // const useMyLocation = () => {
  //   if (!navigator.geolocation) {
  //     setNearbyError("Location is not available in this browser");
  //     return;
  //   }
  //   navigator.geolocation.getCurrentPosition(
  //     (pos) =>
  //       setNearbyInput((prev) => ({
  //         ...prev,
  //         lat: pos.coords.latitude.toFixed(6),
  //         lng: pos.coords.longitude.toFixed(6),
  //       })),
  //     () => setNearbyError("Could not get your location. Enter it manually."),
  //   );
  // };

  const handleAssignContainers = () => {
    setModalMode("create");
    setisMapModalOpen(true);
    setSelectedLocationId(null);
  };

  const handleMapSave = async (data: any) => {
    if (saveInFlight.current) return; // ignore double clicks while a save is pending
    saveInFlight.current = true;
    let saved = false;
    try {
      const payload = {
        name: data.name.trim(),
        address: data.address.trim(),
        latitude: data.lat,
        longitude: data.lng,
        label: data.label || undefined,
      };
      if (modalMode === "edit" && selectedLocationId !== null) {
        saved = await updateLocation(selectedLocationId, payload);
      } else if (modalMode === "create") {
        saved = await createLocation(payload);
      }
    } finally {
      saveInFlight.current = false;
    }
    if (!saved) return; // keep the form open so the entered values are not lost
    setisMapModalOpen(false);
    setModalMode(null);
    setSelectedLocationId(null);
    setSelectedLocation(null);
  };

  // Get location by ID (API or sample)
  const getLocationById = async (id: number) => {
    if (useApi || useDetailsApi) {
      // setLoading(true);
      loader.setLoading(true);
      try {
        const res = await LocationService.getLocationById(id);
        // setLoading(false);
        loader.setLoading(false);

        return res.data.data;
      } catch (err: any) {
        // setLoading(false);
        loader.setLoading(false);

        if (err?.response?.status === 404) return null; // deleted / missing
        throw err; // network or server error: let the caller show a retry message
      }
    } else {
      return sampleLocations.find((loc) => loc.id === id) || null;
    }
  };

  // Fetch fresh details from the API, then open the modal in edit/view mode
  const openLocationModal = async (mode: "edit" | "view", id: number) => {
    let fresh: Location | null;
    try {
      fresh = await getLocationById(id);
    } catch {
      showToast("Could not load location details. Please try again.", "error");
      return;
    }
    if (!fresh) {
      showToast("This location no longer exists", "error");
      setLocationList((prev) => prev.filter((loc) => loc.id !== id));
      return;
    }
    setSelectedLocation(fresh);
    setModalMode(mode);
    setisMapModalOpen(true);
    setSelectedLocationId(id);
  };

  // Create location (API or sample)
  const createLocation = async (data: Partial<Location>): Promise<boolean> => {
    if (useApi || useCreateApi) {
      loader.setLoading(true);
      try {
        const res = await LocationService.createLocation(data);
        // the list is ordered by ID, so the new row would sit on the last page; show it at the top now
        setLocationList((prev) => [res.data.data, ...prev]);
        showToast("Location created successfully", "success");
        return true;
      } catch (err: any) {
        showToast(getErrorMessage(err), "error");
        return false;
      } finally {
        loader.setLoading(false);
      }
    } else {
      setLocationList((prev) => [
        {
          id: prev.length ? Math.max(...prev.map((l) => l.id)) + 1 : 1,
          ...data,
          label: data.label,
          isActive: true,
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString(),
        } as Location,
        ...prev,
      ]);
      return true;
    }
  };

  // Update location (API or sample)
  const updateLocation = async (id: number, data: Partial<Location>): Promise<boolean> => {
    if (useApi || useUpdateApi) {
      loader.setLoading(true);
      try {
        const res = await LocationService.updateLocation(id, data);
        const updated: Location = res.data.data;
        setLocationList((prev) => prev.map((loc) => (loc.id === id ? updated : loc)));
        showToast("Location updated successfully", "success");
        return true;
      } catch (err: any) {
        showToast(
          err?.response?.status === 404
            ? "This location no longer exists"
            : getErrorMessage(err),
          "error"
        );
        if (err?.response?.status === 404) {
          setLocationList((prev) => prev.filter((loc) => loc.id !== id));
          setisMapModalOpen(false);
          setModalMode(null);
          setSelectedLocationId(null);
          setSelectedLocation(null);
        }
        return false;
      } finally {
        loader.setLoading(false);
      }
    } else {
      setLocationList((prev) =>
        prev.map((loc) => (loc.id === id ? { ...loc, ...data } : loc))
      );
      return true;
    }
  };

  // Delete location (API or sample) with confirm dialog
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [locationToDelete, setLocationToDelete] = useState<Location | null>(
    null
  );

  const handleDeleteLocation = (location: Location) => {
    setLocationToDelete(location);
    setDeleteDialogOpen(true);
  };

  const confirmDeleteLocation = async () => {
    if (!locationToDelete || saveInFlight.current) return;
    const id = locationToDelete.id;
    if (useApi || useDeleteApi) {
      saveInFlight.current = true;
      loader.setLoading(true);
      try {
        await LocationService.deleteLocation(id);
        setLocationList((prev) => prev.filter((loc) => loc.id !== id));
        showToast("Location deleted successfully", "success");
      } catch (err: any) {
        if (err?.response?.status === 404) {
          // already deleted elsewhere: drop the stale card
          setLocationList((prev) => prev.filter((loc) => loc.id !== id));
          showToast("This location was already deleted", "info");
        } else {
          showToast(getErrorMessage(err), "error");
          loader.setLoading(false);
          saveInFlight.current = false;
          return; // keep the dialog open so the user can retry
        }
      }
      loader.setLoading(false);
      saveInFlight.current = false;
    } else {
      setLocationList((prev) => prev.filter((loc) => loc.id !== id));
    }
    setDeleteDialogOpen(false);
    setLocationToDelete(null);
  };

  // Helper to get location by id from current list
  const getLocationByIdLocal = (id: number) =>
    selectedLocation?.id === id
      ? selectedLocation
      : locationList.find((loc) => loc.id === id);

  return (
    <div className="transporters-page p-[20px]">
      <div className="flex justify-between items-center py-[30px]">
        <SearchBar
          placeholder="Search Location..."
          onSearch={handleSearchChange}
          showClearButton={true}
        />
        <div className="flex items-center space-x-2">
          <button
            type="button"
            className="primary_button"
            onClick={handleAssignContainers}
          >
            Create New
          </button>
        </div>
        <Modal
          className="assign_containers_modal"
          title={
            modalMode === "edit"
              ? "Edit Location"
              : modalMode === "view"
              ? "View Location"
              : "Create Location"
          }
          isOpen={isMapModalOpen}
          onClose={() => {
            setisMapModalOpen(false);
            setModalMode(null);
            setSelectedLocationId(null);
          }}
        >
          {(modalMode === "edit" || modalMode === "view") &&
          selectedLocationId !== null ? (
            (console.log("modalMode", modalMode),
            (
              <MapWithMarker
                initialLatLng={{
                  lat:
                    getLocationByIdLocal(selectedLocationId)?.latitude ??
                    19.076,
                  lng:
                    getLocationByIdLocal(selectedLocationId)?.longitude ??
                    72.8777,
                }}
                initialName={
                  getLocationByIdLocal(selectedLocationId)?.name || ""
                }
                initialLabel={getLocationByIdLocal(selectedLocationId)?.label || ""}
                initialAddress={
                  getLocationByIdLocal(selectedLocationId)?.address || ""
                }
                onSave={
                  modalMode === "edit"
                    ? handleMapSave
                    : () => setisMapModalOpen(false)
                }
                mode={modalMode}
              />
            ))
          ) : (
            <MapWithMarker onSave={handleMapSave} />
          )}
        </Modal>
      </div>
      {/* Filter row (label dropdown + nearby search) is parked for now; restore this block later.
      <div className="flex flex-wrap items-end gap-3 pb-[10px]">
        <label className="flex flex-col text-sm">
          Label
          <select
            value={label}
            onChange={(e) => setLabel(e.target.value)}
            className="border rounded px-2 py-1"
          >
            <option value="">All</option>
            <option value="WAREHOUSE">Warehouse</option>
            <option value="PORT">Port</option>
            <option value="HUB">Hub</option>
            <option value="PARK">Park</option>
          </select>
        </label>
        {/ * Nearby search is parked for now (uses GET /location/search); restore this block later.
        <label className="flex flex-col text-sm">
          Latitude
          <input
            value={nearbyInput.lat}
            onChange={(e) => setNearbyInput({ ...nearbyInput, lat: e.target.value })}
            placeholder="19.076"
            className="border rounded px-2 py-1 w-[110px]"
          />
        </label>
        <label className="flex flex-col text-sm">
          Longitude
          <input
            value={nearbyInput.lng}
            onChange={(e) => setNearbyInput({ ...nearbyInput, lng: e.target.value })}
            placeholder="72.8777"
            className="border rounded px-2 py-1 w-[110px]"
          />
        </label>
        <label className="flex flex-col text-sm">
          Radius (km)
          <input
            value={nearbyInput.radius}
            onChange={(e) => setNearbyInput({ ...nearbyInput, radius: e.target.value })}
            className="border rounded px-2 py-1 w-[80px]"
          />
        </label>
        <button type="button" className="secondary_button" onClick={useMyLocation}>
          Use my location
        </button>
        <button type="button" className="primary_button" onClick={applyNearby}>
          Find nearby
        </button>
        {nearby && (
          <button type="button" className="secondary_button" onClick={clearNearby}>
            Clear nearby
          </button>
        )}
        {nearbyError && <span style={{ color: "#c82333", fontSize: 13 }}>{nearbyError}</span>}
        {nearby && (
          <span style={{ fontSize: 13 }}>
            Nearest first within {nearby.radius} km (max 500 shown)
          </span>
        )}
        * /}
      </div>
      */}
      <div>
        {globalLoading && !locationsLoaded && !initialLoadDone.current ? (
          <FullPageLoader />
        ) : (
          <>
            {showTopBarLoader && (
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "4px",
                  background:
                    "linear-gradient(90deg, #1062b9 0%, #1062b9 100%)",
                  zIndex: 1000,
                  animation: "loader-bar 1s linear infinite",
                }}
              />
            )}
            <div
              className="location-card-grid"
              ref={gridRef}
              style={{ maxHeight: "80vh", overflowY: "auto" }}
            >
              {locationList.map((location) => (
                <LocationCard
                  key={location.id}
                  data={location}
                  onEdit={() => openLocationModal("edit", location.id)}
                  onDelete={() => handleDeleteLocation(location)}
                  onView={() => openLocationModal("view", location.id)}
                />
              ))}
              <ConfirmDialog
                open={deleteDialogOpen}
                onClose={() => setDeleteDialogOpen(false)}
                onConfirm={confirmDeleteLocation}
                title="Delete Location"
                message={`Are you sure you want to delete location ${locationToDelete?.name}? This action cannot be undone.`}
                confirmText="Delete"
                cancelText="Cancel"
                confirmColor="error"
              />
              {loader.isLoading && locationsLoaded && (
                <div style={{ textAlign: "center", padding: 16 }}>
                  Loading...
                </div>
              )}
            </div>
            {locationsLoaded &&
              !loader.isLoading &&
              locationList.length === 0 && (
                <div className="center_floater_container">
                  <div className="no_data_wrapper">
                    <img
                      className="info_graphics"
                      src={noJobInfoGraphics}
                      alt="No Location"
                    />
                    <div className="msg">No Locations </div>
                  </div>
                </div>
              )}
          </>
        )}
      </div>
    </div>
  );
}

export default LocationPage;
